import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { datadogLogs } from '@datadog/browser-logs';

if (environment.production) {
  enableProdMode();
}

if (environment.datadogClientToken) {
  datadogLogs.init({
    clientToken: environment.datadogClientToken,
    site: 'datadoghq.com',
    env: environment.production ? 'prod' : 'dev',
    version: environment.appVersionNumber,
    service: environment.name.toLowerCase(),
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    beforeSend: (_, context) => {
      if ('isAborted' in context) {
        return !context.isAborted;
      }
      return true;
    }
  });

  if (environment.vpcName) {
    datadogLogs.setGlobalContextProperty('aws_account_name', environment.vpcName);
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
